import { ContentItem, Elements } from '@kentico/kontent-delivery';

/**
 * Generated by Raaz Khoshnood Manually
 * Tip: You can replace 'ContentItem' with another generated class to fully leverage strong typing.
 */
export class FundNote extends ContentItem {
  public feastName: Elements.MultipleChoiceElement;
  public englishPdf: Elements.AssetsElement;
  public persianPdf: Elements.AssetsElement;
  public png: Elements.AssetsElement;
  public contributionsAsOf: Elements.DateTimeElement;
  public nationalFund: Elements.TextElement;
  public regionalFund: Elements.TextElement;
  public continentalFund: Elements.TextElement;
  public internationalFund: Elements.TextElement;
  public shrineOfAbdulBahaFund: Elements.TextElement;
  constructor() {
    super({
      propertyResolver: (elementName: string) => {
        if (elementName === 'feast_name') {
          return 'feastName';
        }
        if (elementName === 'english_pdf') {
          return 'englishPdf';
        }
        if (elementName === 'persian_pdf') {
          return 'persianPdf';
        }
        if (elementName === 'png') {
          return 'png';
        }
        if (elementName === 'contributions_as_of') {
          return 'contributionsAsOf';
        }
        if (elementName === 'national_fund') {
          return 'nationalFund';
        }
        if (elementName === 'regional_fund') {
          return 'regionalFund';
        }
        if (elementName === 'continental_fund') {
          return 'continentalFund';
        }
        if (elementName === 'international_fund') {
          return 'internationalFund';
        }
        if (elementName === 'shrine_of__abdu_l_baha_fund') {
          return 'shrineOfAbdulBahaFund';
        }
        return elementName;
      },
    });
  }
}
